<template>
  <div name="hresh1x-detail">
    <div  class="box">
      <div class="box-body">

        <div class="detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['10'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ codempid }} - {{ descCodempid }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRPM4GEC2']['20'] }}</label>
              <div class="col-md-5">
                <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.dtemistk) }}</div>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion"> 

        <detail-tab1 :labels="labels"
                     :data="detail.tab1" />
    
        <detail-tab2 :labels="labels"
                     :data="detail.tab2" />
 
        <detail-tab3 :labels="labels"
                     :data="detail.tab3"
                     :tab3Table="tab3Table" />

        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>   
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import detailTab1 from 'components/hresh1x/detailTab1'
import detailTab2 from 'components/hresh1x/detailTab2'
import detailTab3 from 'components/hresh1x/detailTab3'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hresh1x-detail',
  props: [ 'labels',
    'labelsButton',
    'detail',
    'codempid',
    'descCodempid',
    'nowLang',
    'toggle',
    'indexSelected',
    'tab3Table'
  ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  },
  components: {
    detailTab1,
    detailTab2,
    detailTab3
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?459ac397